export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_POSITION = 'position';
export const COLUMN_MANAGER = 'manager';
export const COLUMN_DEPARTMENT = 'department';
export const COLUMN_LAST_LOGIN = 'lastLogin';
export const COLUMN_REG_DATE = 'regDate';
export const COLUMN_COMPANY = 'company';
export const COLUMN_STUDIO = 'studio';
export const COLUMN_TEAM = 'team';
export const COLUMN_OWNER = 'owner';
export const COLUMN_SUPER_TEAM = 'superTeam';
export const COLUMN_TEST = 'isTest';
export const STATUS_ACTIVE = 0;

export const COMBINED_PAGES = [
  { id: 72, name: 'Influencers Marketing' },
  { id: 60, name: 'Partner Management (PCs, BPs and Affiliates)' },
  { id: 9, name: 'Audience Management' },
  { id: 3, name: 'Campaigns' },
];

export const FILTER_COMPANIES = 'companyIds';
export const FILTER_STUDIOS = 'studioIds';
export const FILTER_DEPARTMENTS = 'departmentIds';
export const FILTER_MANAGERS = 'managerIds';
export const FILTER_ACTIONS = 'actionIds';
export const FILTER_PAGES = 'pageIds';
export const FILTER_AFFILIATES = 'affiliateIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_SHOW = 'filterOptionIds';

export const PERMISSION_ACTION_SEE_ALL_AFFILIATES = 22;
